import { type FC } from 'react';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { ROUTES } from '@/constants/routes';
import { PAGE_TITLE } from '@/components/ui/typography';

// Renders in the deepest matched layout, or under the root alone, so it reads eager namespaces only.
export const RouteNotFound: FC = () => {
  const { t } = useTranslation('nav');
  return (
    <main className="flex min-h-[60vh] items-center justify-center p-6">
      <div className="flex max-w-md flex-col items-start gap-3">
        <h1 className={PAGE_TITLE}>{t('not_found.title')}</h1>
        <p className="text-fg-3 text-fs-14 leading-relaxed">
          {t('not_found.description')}
        </p>
        <Link to={ROUTES.HOME} className="text-fs-13 text-fg-1 underline">
          {t('not_found.go_home')}
        </Link>
      </div>
    </main>
  );
};
